export enum ChainStatus {    
    Active = 1,
    Broken = 2,
    Ended = 3
}